import React from "react";
import ReactDOM from "react-dom";
// import "./index.css";
import * as serviceWorker from "./serviceWorker";
import Theme from "./themes/default";
import "../node_modules/witmeg-ui-system/dist/styles.css"
import { Provider } from "react-redux";
import store from './redux/rootreducer'
import globalValues from "./themes/default/utilities/apiRequests/globalValues";
import { LoadScript } from "@react-google-maps/api";
const libraries = ["places"];

if (process.env.NODE_ENV === "production") {
    console.log = function () { };
}
ReactDOM.render(
    // <React.StrictMode>
    <Provider store={store}>
        <LoadScript
            googleMapsApiKey={globalValues.keys.REACT_APP_LOCATION_GOOGLE_API_KEY}
            libraries={libraries}
        >
            <Theme />
        </LoadScript>
    </Provider>,
    // </React.StrictMode>,
    document.getElementById("root")
);

serviceWorker.unregister();
